import script from "./NoteSection.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteSection.vue?vue&type=script&setup=true&lang=js"

import "./NoteSection.vue?vue&type=style&index=0&id=49eba8d5&lang=css"

const __exports__ = script;

export default __exports__